global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $

import Vue from 'vue';
import App from './App.vue';
import store from './store';
import VueRouter from 'vue-router';
import { routes, publicRoutes } from './router/routes';
import { index } from './components/index';
import auth from './lib/auth';
import config from './lib/config';
import JsonExcel from 'vue-json-excel';
import SimpleVueValidation from 'simple-vue-validator';
import Vuebar from './lib/vuebar.js';
import VueDragscroll from 'vue-dragscroll';
Vue.use(VueDragscroll);
Vue.use(Vuebar);
//Validations
Vue.use(SimpleVueValidation, { mode: 'manual' });

// Tabs
import VueTabs from 'vue-nav-tabs';
Vue.use(VueTabs);
Vue.component('downloadExcel', JsonExcel);


import VueToastr2 from 'vue-toastr-2';
import 'vue-toastr-2/dist/vue-toastr-2.min.css';
window.toastr = require('toastr');
Vue.use(VueToastr2);


if (!window.webpackHotUpdate) {
  console.log = function () { };
}
// Router
Vue.use(VueRouter);
const router = new VueRouter({
  routes,
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash'
});
// set user if authenticated and authorization header.
auth.checkAuth();
window.user = auth.user;
window.jQuery = jQuery;
window.event = new Vue();
router.beforeEach((to, from, next) => {
  if (publicRoutes.indexOf(to.path) === -1) {
    console.log('accessing preotected path', to, from, next, auth);
    if (!auth.user.authenticated || !auth.user.sections) {
      auth.user.authenticated = false;
      console.log('redirecting to login');
      return next('/auth/login');
    } else {
      if (to.path === '/' && auth.user.sections[0] === 'Dashboard') {
        return next();
      } else if(to.path === '/' && (auth.user.sections[0] !== 'Dashboard')) {
        return next(auth.user.sections[0]);
      } else {
        return next();
      }
    }
  }
  next();
});


new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js